import src from "IMAGE";
export default { src, width: 1232, height: 1, blurWidth: 0, blurHeight: 0};
